export const getData = () => {
  return [
    {
      id: "TR001234",
      customer_name: "John Doe",
      bar_name: "sky",
      mobile: 1234567890,
      email_id: "johndoe@example.com",
      no_of_shots: 10,
      no_of_quantity: 2,
      total_amount: 100.0,
      payment_status: "paid",
    },
    {
      id: "TR001235",
      customer_name: "Jane Doe",
      bar_name: "sky",
      mobile: 9876543210,
      email_id: "janedoe@example.com",
      no_of_shots: 5,
      no_of_quantity: 3,
      total_amount: 150.0,
      payment_status: "paid",
    },
    {
      id: "TR001236",
      customer_name: "Bob Smith",
      bar_name: "sky",
      mobile: 5551234567,
      email_id: "bobsmith@example.com",
      no_of_shots: 8,
      no_of_quantity: 1,
      total_amount: 50.0,
      payment_status: "unpaid",
    },
    {
      id: "TR001237",
      customer_name: "Alice Johnson",
      bar_name: "sky",
      mobile: 1112223333,
      email_id: "alicejohnson@example.com",
      no_of_shots: 12,
      no_of_quantity: 4,
      total_amount: 200.0,
      payment_status: "paid",
    },
    {
      id: "TR001238",
      customer_name: "Mike Brown",
      bar_name: "sky",
      mobile: 4445556666,
      email_id: "mikebrown@example.com",
      no_of_shots: 15,
      no_of_quantity: 2,
      total_amount: 100.0,
      payment_status: "paid",
    },
    {
      id: "TR001239",
      customer_name: "Emily Davis",
      bar_name: "sky",
      mobile: 7778889999,
      email_id: "emilydavis@example.com",
      no_of_shots: 18,
      no_of_quantity: 3,
      total_amount: 150.0,
      payment_status: "paid",
    },
    {
      id: "TR001240",
      customer_name: "David Lee",
      bar_name: "sky",
      mobile: 3334445555,
      email_id: "davidlee@example.com",
      no_of_shots: 20,
      no_of_quantity: 1,
      total_amount: 50.0,
      payment_status: "unpaid",
    },
  ];
};

export const consumedData = () => {
  return [
    {
      id: "TR001234",
      customer_name: "John Doe",
      mobile: 1234567890,
      barname: "Bar 1",
      product_name: "Product 1",
      no_of_shots: 10,
      used_shots: 5,
      available_shots: 5,
      used_date: "2022-01-01",
      time: "10:00",
    },
    {
      id: "TR001235",
      customer_name: "Jane Smith",
      mobile: 9876543210,
      barname: "Bar 2",
      product_name: "Product 2",
      no_of_shots: 15,
      used_shots: 10,
      available_shots: 5,
      used_date: "2022-01-02",
      time: "11:00",
    },
  ];
};
